import React, { ReactNode } from 'react';
import { Flex, Typography, Banner } from '@fullstory/components';

interface Props {
  text: string;
  children?: ReactNode;
}

export const RuleWarning: React.FC<Props> = ({ text, children }) => (
  <Banner
    variant="warning"
    description={
      <Flex column alignItems="flex-start">
        <Typography variant="body2">{text}</Typography>
        {children}
      </Flex>
    }
  />
);
